var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 14.9974C19.1667 15.6224 18.9917 16.2141 18.6833 16.7141C18.5083 17.0141 18.2833 17.2807 18.025 17.4974C17.4417 18.0224 16.675 18.3307 15.8333 18.3307C14.8167 18.3307 13.9083 17.8724 13.3083 17.1558C13.2917 17.1308 13.2667 17.1141 13.25 17.0891C13.15 16.9724 13.0583 16.8474 12.9833 16.7141C12.675 16.2141 12.5 15.6224 12.5 14.9974C12.5 13.9474 12.9833 13.0057 13.75 12.3974C14.325 11.9391 15.05 11.6641 15.8333 11.6641C16.6667 11.6641 17.4167 11.964 18 12.4724C18.1 12.5474 18.1917 12.6391 18.275 12.7308C18.825 13.3308 19.1667 14.1224 19.1667 14.9974Z",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0751 14.9844H14.5918",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8335 13.7656V16.2573",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6416 6.19531L9.99994 10.4536L17.3083 6.22029",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.0037V10.4453",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.9917 12.3558V7.63906C1.9917 6.48906 2.8167 5.08908 3.82503 4.53075L8.27503 2.06406C9.22503 1.53073 10.775 1.53073 11.725 2.06406L16.175 4.53075C17.1834 5.08908 18.0084 6.48906 18.0084 7.63906V12.3558C18.0084 12.3974 18.0084 12.4307 18 12.4724C17.4167 11.9641 16.6667 11.6641 15.8334 11.6641C15.05 11.6641 14.325 11.9391 13.75 12.3974C12.9834 13.0057 12.5 13.9474 12.5 14.9974C12.5 15.6224 12.675 16.2141 12.9834 16.7141C13.0584 16.8474 13.15 16.9724 13.25 17.0891L11.725 17.9308C10.775 18.4641 9.22503 18.4641 8.27503 17.9308L3.82503 15.4641",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxAdd);
export default __webpack_public_path__ + "static/media/boxAdd.bd28bc5f76532e874afd9df61a01e296.svg";
export { ForwardRef as ReactComponent };